<template>
  <div class="common-layout">
    <el-container>
      <el-header>
        <MyHeader />
      </el-header>
      <el-main>
        <router-view/>
      </el-main>
      <el-footer>
        <MyFooter />
      </el-footer>
    </el-container>
  </div>
</template>


<script>
// @ is an alias to /src
import MyHeader from '@/components/header.vue'
import MyFooter from '@/components/footer.vue'

export default {
  name: 'App',
  components: {
    MyHeader,
    MyFooter
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  min-width: 1280px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-header {
  padding: 0 !important;
  height: 90px !important;
}

.el-main {
  padding: 0 !important;
}

.el-footer {
  padding: 0 !important;
  color: #FFFFFF;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 16px;
}


@media (max-width: 1920px) {
  .el-header {
    height: 60px !important;
  }
}

</style>
